// removed by extract-text-webpack-plugin
module.exports = {"intro-photos":"index-module__intro-photos___2sM6O","introPhotos":"index-module__intro-photos___2sM6O","left-col":"index-module__left-col___3Zkf5","leftCol":"index-module__left-col___3Zkf5","right-col":"index-module__right-col___2ibph","rightCol":"index-module__right-col___2ibph","copy":"index-module__copy___29khk","logoIcon":"index-module__logoIcon___3xbBE"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/pages/company/intro/index.module.scss
// module id = 1714
// module chunks = 146